export default {
    methods: {
        concat(first, second = null, glue = ' - ') {
            return second ? first + glue + second : first;
        },
        getFullPhoneNumber({CountryCode, PhoneNumber, PhoneExtension}) {
            let number = '';
            if (CountryCode) {
                number = `+${CountryCode} `;
            }

            number += PhoneNumber;

            if (PhoneExtension) {
                number += ` ${PhoneExtension}`;
            }

            return number;
        },
    },
};
